module.exports = __webpack_public_path__ + "assets/img/icon_voice_active.f0d7ee39.svg";